import _ from 'lodash'
import { getUrlParams } from 'action/explorer'
import CryptoJS from "crypto-js"
import { ENCRYPTION_KEY } from 'js/constant/explorer-builder'
import md5 from 'md5'; 
import { faCropSimple } from '@fortawesome/free-solid-svg-icons';
import { getSavedEncriptedParams } from '../network-url-decoder';

export const splitRangeIntoEqualParts = (start, end, parts) => {
  const range = end - start
  const interval = range / parts
  const result = []

  for (let i = 0; i < parts; i++) {
    const partStart = start + i * interval
    const partEnd = start + (i + 1) * interval
    result.push([Math.floor(partStart), Math.floor(partEnd)])
  }
  return result
}

export const splitNumber = (number, range) => {
  const ranges = []
  for (let i = 0; i < number; i += range) {
    ranges.push([i, Math.min(i + range, number)])
  }
  return ranges
}

export const splitArray = (number) => {
  const ranges = []
  for (let i = 0; i < number; i += 100) {
    ranges.push([i, Math.min(i + 100, number)])
  }
  return ranges
}

export const divideArrayIntoGroups = (array, groupSize) => {
  const result = []
  for (let i = 0; i < array.length; i += groupSize) {
    result.push(array.slice(i, i + groupSize))
  }
  return result
}

export const getRandomInt = (min, max) => {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min) + min)
}

export const getAppliedFilters = (allFilters, appliedFilters) => Object.keys(allFilters)
  .filter(key => appliedFilters.includes(key))
  .reduce((obj, key) => {
    obj[key] = allFilters[key]
    return obj
}, {})


/**
 * Decrypt the encrypted URL params.
 * @param {string} params The URL params that describe the network data.
 * @returns The decrypted URL params.
 */
export const decryptUrlParams = (params) => {

  if (params.includes("?params=")) {
    params = params.split("?params=")[1]
  }

  if (params.length > 0) {
    var decryptedString = params;

    // If the params are encrypted...
    if (params.startsWith("WdVEnc")) {

      var encryptedString = params.substring(6)
      
      try {
        console.log("About to decrypt this:", encryptedString)
        decryptedString = CryptoJS.AES.decrypt(encryptedString, ENCRYPTION_KEY).toString(CryptoJS.enc.Utf8)

        if (decryptedString && decryptedString.length > 1) {
          return decryptedString
        } else {
          return params;
        }
      } catch (ex) {
        console.log("Failed to decrypt params.", ex)
      }
    } else {
      console.log("The params were NOT encrypted.", params)
    }

    return decryptedString.replace(/%20/g, " ");
  } else {
    console.log("Failed to decrypt params: Params was empty.")
  }
}

/**
 * Encrypt the network data.
 * @param {string} params The URL params that describe the network data.
 * @param {bool} force Force the string to be encrypted.
 * @returns 
 */
export const encryptUrlParams = (params, force = false) => {

  if (params.includes("?params=")) {
    params = params.split("?params=")[1]
  }

  // If the parameters are not already hashed or encrypted...
  if ((!params.startsWith("WdVEnc") && !params.startsWith("WdV101")) || force) {
    // Append a substring so we know it is encrypted.
    var encryptedString = CryptoJS.AES.encrypt(params, ENCRYPTION_KEY).toString()
    return `WdVEnc${encryptedString}`;
  } else {
    console.log("Failed to encrypt the string: ", )
  }

  return params;
}

/**
 * Get the hash for the encrypted URL params.
 * @param {string} value The encrypted URL params 
 * @returns 
 */
export const getHash = (value) => {

  var hash = md5(value)

  // Append this string so we know it is hashed.
  return `WdV101${hash}`;
}

